import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'esriDate',
    standalone: false
})
export class EsriDatePipe implements PipeTransform {
  transform(value: number): string {
    let dateString = '';

    if (value && value != null) {
      const date: Date = new Date(value);
      dateString = date.toLocaleDateString();
    }

    return dateString;
  }
}
